import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { FieldInfoContainer } from "./styles";
import { AnimatePresence } from "framer-motion";
export var FieldInfo = forwardRef(function FieldInfo(_a, ref) {
    var isError = _a.isError, isDisabled = _a.isDisabled, children = _a.children, props = __rest(_a, ["isError", "isDisabled", "children"]);
    return (_jsx(AnimatePresence, { initial: false, children: children && (_jsx(FieldInfoContainer, __assign({ initial: { height: 0 }, animate: { height: "auto" }, exit: { height: 0 }, transition: { duration: 0.3 }, "$isDisabled": isDisabled, "$isError": isError, ref: ref }, props, { children: children }))) }));
});
//# sourceMappingURL=index.js.map